import { render } from "./LegalNotices.vue?vue&type=template&id=84870d08&scoped=true"
import script from "./LegalNotices.vue?vue&type=script&lang=js"
export * from "./LegalNotices.vue?vue&type=script&lang=js"

import "./LegalNotices.vue?vue&type=style&index=0&id=84870d08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84870d08"]])

export default __exports__